<ng-template #itemTemplate let-item>
    <div #highlightElement [ngClass]="{ 'font-bold': highlightItemCheck(item, highlightElement) }">
        @if (item.isPrimary) {
            <i
                [pTooltip]="'postal-address.is-primary-tooltip' | translate"
                class="fa-solid fa-house text-primary me-1"
            ></i>
        }
        @if (item.isDefault) {
            <i
                [pTooltip]="'postal-address.is-favorite-tooltip' | translate"
                class="fa-solid fa-star text-primary me-1"
            ></i>
        }
        <span *ngIf="item.postalAddress?.recipient">
            {{ item.postalAddress?.recipient }}
        </span>
        <span
            *ngIf="
                item.postalAddress?.recipient &&
                (item.postalAddress?.street ||
                    item.postalAddress?.streetNumber ||
                    item.postalAddress?.postalCode ||
                    item.postalAddress?.city ||
                    item.postalAddress?.country)
            "
            >{{ ', ' }}
        </span>
        <span *ngIf="item.postalAddress">
            {{ item.postalAddress?.street ? item.postalAddress?.street : '' }}
            {{ item.postalAddress?.streetNumber ? ' ' + item.postalAddress?.streetNumber : '' }}
            <span
                *ngIf="
                    item.postalAddress?.street &&
                    (item.postalAddress?.postalCode || item.postalAddress?.city)
                "
                >{{ ', ' }}</span
            >
            {{ item.postalAddress?.postalCode ? item.postalAddress?.postalCode : '' }}
            <span *ngIf="item.postalAddress?.postalCode && item.postalAddress?.city">{{
                ' '
            }}</span>
            {{ item.postalAddress?.city ? item.postalAddress?.city : '' }}
            <!-- add a - when there is a country -->
            <span
                *ngIf="
                    item.postalAddress?.countryIso &&
                    (item.postalAddress?.city ||
                        item.postalAddress?.postalCode ||
                        item.postalAddress?.street)
                "
                >{{ ', ' }}</span
            >
            {{ item.postalAddress?.countryIso ? item.postalAddress?.countryIso : '' }}
        </span>
    </div>
</ng-template>
<ng-template #groupTemplate let-group>
    <span>{{ group?.label }}</span>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    @if (showSelection && item) {
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
    } @else {
        <span class="text-gray-400" [ngClass]="{ 'text-red-500': isBlocked() }">
            <!-- {{ this.generateLabel(item) }} -->
            {{ 'postal-address.choose-postal-address' | translate }}
        </span>
    }
</ng-template>
